import axios from 'axios';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

let previousErrorCode = 0;

const api = axios.create({
  baseURL: process.env.VUE_APP_API_LINK,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  async function (config) {
    const accessToken = localStorage.getItem('accessToken');
    config.headers.Authorization = `Bearer ${accessToken}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    if (process.env.VUE_APP_NOTIFICATIONS === 'true') {
      ElementUI.Notification({
        message: response.config.url,
        type: 'success',
        duration: 3000,
        position: 'bottom-right',
      });
    }
    return response;
  },
  function (error) {
    if (error.response.status === 401) {
      if (previousErrorCode !== 401) {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('regionId');
        localStorage.removeItem('accessUserName');
        ElementUI.Message({
          type: 'error',
          message: 'Sessão expirada. Redirecionando...',
        });
        setTimeout(() => {
          window.location.href = '/login';
        }, 1500);
      }
    }
    previousErrorCode = error.response.status;
    if (process.env.VUE_APP_NOTIFICATIONS === 'true') {
      ElementUI.Notification({
        title: `${error.config.url}`,
        message: error.response.data.error,
        type: 'error',
        duration: 0,
        position: 'bottom-right',
      });
    }
    return Promise.reject(error);
  }
);

export default api;
